import { render } from "./followupChart.vue?vue&type=template&id=3c3a46ee"
import script from "./followupChart.vue?vue&type=script&lang=js"
export * from "./followupChart.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Projects\\KneeLeadNew\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__